/**
 * Resolves the name to display for a contact, preferring their display name and falling back
 * to their first and last name when no display name is set
 *
 * @param firstName Contact's first name
 * @param lastName Contact's last name
 * @param displayName Contact's optional display name (e.g. name printed on envelope)
 * @returns The resolved display name
 */
export const getDisplayName = (firstName: string, lastName: string, displayName?: string): string => {
  return displayName?.trim() || `${firstName} ${lastName}`.trim();
};
